module.exports = __webpack_public_path__ + "static/media/Detail_Icon_01_hovered.4ac73c2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/Detail_Icon_01_hovered.png
// module id = 1576
// module chunks = 0